import checkUndefined from "./checkUndefined";
var updateFormValues = function (data) {
    var _a, _b, _c, _d;
    var phoneNumbers = ((_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.phone) || [];
    var mailingAddress = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.mailingAddress;
    var emailAddress = ((_c = data === null || data === void 0 ? void 0 : data.profile) === null || _c === void 0 ? void 0 : _c["cipher.email"]) || "";
    var annualNetIncome = ((_d = data === null || data === void 0 ? void 0 : data.profile) === null || _d === void 0 ? void 0 : _d["cipher.annualNetIncome"]) || "";
    var findPhoneNumber = function (type, numbers) {
        var foundPhoneNumber = numbers.find(function (phone) { return phone.contactType === type; });
        return (foundPhoneNumber === null || foundPhoneNumber === void 0 ? void 0 : foundPhoneNumber["cipher.contactNumber"]) || "";
    };
    return {
        phoneNumbers: {
            mobile: findPhoneNumber("MOBILE", phoneNumbers),
            home: findPhoneNumber("HOME", phoneNumbers),
            business: findPhoneNumber("BUSINESS", phoneNumbers),
        },
        mailingAddress: {
            street1: checkUndefined(mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress["cipher.addressLine1"]),
            street2: checkUndefined(mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress["cipher.addressLine2"]),
            city: checkUndefined(mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress["cipher.city"]),
            state: checkUndefined(mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress["cipher.state"]),
            zipCode: checkUndefined(mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress["cipher.zipCode"]),
        },
        emailAddress: emailAddress,
        annualNetIncome: annualNetIncome,
    };
};
export default updateFormValues;
